import { render, staticRenderFns } from "./newFoot.vue?vue&type=template&id=90767630&scoped=true"
import script from "./newFoot.vue?vue&type=script&lang=js"
export * from "./newFoot.vue?vue&type=script&lang=js"
import style0 from "./newFoot.vue?vue&type=style&index=0&id=90767630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90767630",
  null
  
)

export default component.exports